import home_children from './home_children'
// import reporting from './reporting'
import patients_children from './patients'
import admin_children from './admin'

const main_routes = [
    {
        path: '/',
        name: 'root',
        redirect: '/home/dashboard',
        // component: () => import('@/views/Home.vue'),
        meta: {
            require_auth: true, // Only show when logged in or logged out. null shows always.
            require_role: [], // Require ONE of these roles for access
            title: 'Home', // Display name for use in side menu, etc
            icon: 'HomeIcon', // The feather icon to be used when identifying this page
            slug: 'home', // Used to identify active route when in child routers
            searchable: true, // Allow search to find this route
            param_restrictions: {
                // Restricts the options for url parameters
                // action: [] // Restrict param 'action' to the specified routes
            }
        }
    },
    {
        path: '/home',
        name: 'home',
        redirect: '/home/dashboard',
        component: () => import('@/views/requests/Main.vue'),
        meta: {
            require_auth: true,
            require_role: [],
            title: 'Home',
            icon: 'HomeIcon',
            slug: 'home',
            searchable: true
        },
        children: home_children
    },
    {
        path: '/patients',
        name: 'patients',
        redirect: '/patients/',
        component: () => import('@/views/patients/Main.vue'),
        meta: {
            require_auth: true,
            require_role: ['ADMIN_OFFICER', 'ADMINISTRATOR', 'SuperUser'],
            title: 'Patients',
            icon: 'UserCheckIcon',
            slug: 'patients',
            searchable: true
        },
        children: patients_children
    },
    {
        path: '/admin',
        name: 'admin',
        redirect: '/admin/practices',
        component: () => import('@/views/admin/Main.vue'),
        meta: {
            require_auth: true,
            require_role: ['ADMINISTRATOR', 'SuperUser'],
            title: 'Admin',
            icon: 'SettingsIcon',
            slug: 'admin',
            searchable: true
        },
        children: admin_children
    }
]

export default main_routes
